interface DayPoint {
  label: string;
  count: number;
}

interface WeeklyActivityProps {
  data: DayPoint[];
}

export default function WeeklyActivity({ data }: WeeklyActivityProps) {
  const max = Math.max(1, ...data.map((point) => point.count));

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
      <div className="flex items-center justify-between">
        <h2 className="text-base font-heading font-semibold text-foreground-950">
          Solicitudes · últimos 7 días
        </h2>
        <span className="flex items-center gap-1.5 text-xs font-label text-foreground-500">
          <i className="ri-bar-chart-line text-sm leading-none" aria-hidden="true"></i>
          Actividad reciente
        </span>
      </div>

      <div className="mt-6 flex h-40 items-end justify-between gap-2">
        {data.map((point) => {
          const heightPct = point.count === 0 ? 4 : Math.round((point.count / max) * 100);
          return (
            <div key={point.label} className="flex flex-1 flex-col items-center gap-2">
              <span className="text-xs font-label font-semibold text-foreground-600">
                {point.count}
              </span>
              <div className="flex h-28 w-full items-end">
                <div
                  className={`w-full rounded-t-md ${
                    point.count === 0 ? "bg-background-200" : "bg-primary-500"
                  }`}
                  style={{ height: `${heightPct}%` }}
                  aria-hidden="true"
                ></div>
              </div>
              <span className="text-xs capitalize text-foreground-500">{point.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}